// @ts-nocheck
import { useState, useEffect, useMemo } from "react";
import { Form } from "react-bootstrap";
import "./Correcao.css";

const Correcao = ({
  idCampo,
  initialValue = {},
  onChange,
  erro = false,
  isSindicato = false,
  visible = false,
}) => {
  const [solicitado, setSolicitado] = useState("");
  const [obsAnalista, setObsAnalista] = useState("");
  const [obsSindicato, setObsSindicato] = useState("");

  const baseId = `correcao-${idCampo || "default"}`;
  const idSolicitado = `${baseId}-solicitado`;
  const idObsAnalista = `${baseId}-obs-analista`;
  const idObsSindicato = `${baseId}-obs-sindicato`;

  const initial = useMemo(() => {
    const rawSolicitado =
      initialValue?.solicitado ??
      initialValue?.Solicitado ??
      initialValue?.dataSolicitacao ??
      "";

    const rawObsAnalista =
      initialValue?.obsAnalista ?? initialValue?.ObsAnalista ?? "";

    const rawObsSindicato =
      initialValue?.obsSindicato ?? initialValue?.ObsSindicato ?? "";

    return {
      solicitado: rawSolicitado || "",
      obsAnalista: rawObsAnalista ?? "",
      obsSindicato: rawObsSindicato ?? "",
    };
  }, [initialValue]);

  useEffect(() => {
    if (!visible) return;

    setSolicitado((prev) => prev || initial.solicitado || "");

    if (
      initial.obsAnalista !== undefined &&
      initial.obsAnalista !== obsAnalista
    ) {
      setObsAnalista(initial.obsAnalista || "");
    }

    if (
      initial.obsSindicato !== undefined &&
      initial.obsSindicato !== obsSindicato
    ) {
      setObsSindicato(initial.obsSindicato || "");
    }
  }, [visible, initial, obsAnalista, obsSindicato]);

  const handleChange = (field, value) => {
    const novoEstado = {
      solicitado,
      obsAnalista,
      obsSindicato,
    };

    if (field === "obsAnalista") {
      setObsAnalista(value);
      novoEstado.obsAnalista = value;
    }

    if (field === "obsSindicato") {
      setObsSindicato(value);
      novoEstado.obsSindicato = value;
    }

    onChange?.(idCampo, novoEstado);
  };

  if (!visible) return null;

  return (
    <div className={`correcao-card ${erro ? "erro" : ""}`}>
      <h6 className="correcao-titulo">SOLICITAÇÃO DE CORREÇÃO</h6>

      <Form.Group className="mb-3" controlId={idSolicitado}>
        <Form.Label>Solicitado em:</Form.Label>
        <Form.Control
          id={idSolicitado}
          type="datetime-local"
          value={solicitado}
          disabled
          readOnly
        />
      </Form.Group>

      <Form.Group className="mb-3" controlId={idObsAnalista}>
        <Form.Label>Observação analista:</Form.Label>
        <Form.Control
          id={idObsAnalista}
          as="textarea"
          rows={2}
          value={obsAnalista}
          disabled={!!isSindicato}
          onChange={(e) => handleChange("obsAnalista", e.target.value)}
        />
      </Form.Group>

      <Form.Group className="mb-3" controlId={idObsSindicato}>
        <Form.Label>Observação sindicato:</Form.Label>
        <Form.Control
          id={idObsSindicato}
          as="textarea"
          rows={3}
          maxLength={1000}
          value={obsSindicato}
          onChange={(e) => handleChange("obsSindicato", e.target.value)}
          disabled={!isSindicato}
          className={erro && !obsSindicato ? "is-invalid" : ""}
        />
        <div className="correcao-limit">Limite máximo: 1.000 caracteres</div>
        {erro && !obsSindicato && (
          <div className="invalid-feedback d-block">Campo obrigatório*</div>
        )}
      </Form.Group>
    </div>
  );
};

export default Correcao;
